import {
	Text,
	HStack,
	Button,
	VStack,
	TextArea,
} from '@montel/montelpro-shared-components-v2';
import { StandardModal } from 'components/common/Modal/StandardModal';
import { FunctionComponent, useState } from 'react';
import { RequestStatus } from 'types/RequestStatus';

interface ConfirmationModalProps {
	showModal: boolean;
	setShowModal: (showModal: boolean) => void;
	onSubmit: (comment?: string) => void;
	header: string;
	text: string;
	buttonText: string;
	loadingStatus: RequestStatus;
	loadingText?: string;
}

export const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = ({
	showModal,
	setShowModal,
	onSubmit,
	header,
	text,
	buttonText,
	loadingStatus,
	loadingText = 'Updating...',
}) => {
	const [comment, setComment] = useState<string>('');
	const onSubmitted = async () => {
		onSubmit(comment);
	};

	const onCloseModal = () => {
		setShowModal(false);
	};

	return (
		<StandardModal
			isOpen={showModal}
			onClose={onCloseModal}
			header={header}
			footer={
				<HStack gap="md">
					<Button
						text={buttonText}
						size="sm"
						type="submit"
						isLoading={loadingStatus === RequestStatus.LOADING}
						loadingText={loadingText}
						onClick={onSubmitted}
					/>
					<Button
						text="Cancel"
						size="sm"
						variant="secondary"
						onClick={onCloseModal}
					/>
				</HStack>
			}
		>
			<VStack gap="lg">
				<Text>{text}</Text>
				<TextArea
					type="text"
					label="Comment"
					placeholder="Please provide a reason"
					autoComplete="off"
					name="comment"
					value={comment}
					onChange={(event) => setComment(event.target.value)}
				/>
			</VStack>
		</StandardModal>
	);
};
